import { render, staticRenderFns } from "./home.vue?vue&type=template&id=19b44530&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=19b44530&prod&lang=less&scoped=true"
import style1 from "./home.vue?vue&type=style&index=1&id=19b44530&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b44530",
  null
  
)

export default component.exports